import { AnimatePresence, motion, Variants } from 'framer-motion'
import { GlassesOutline } from 'react-ionicons'
import { IonIcon } from '@/src/icons'
import { Container } from '@/components/utils'
import { SectionTitle } from '@/components/elements/SectionTitle'
import {
  BillboardCard,
  BillboardCardProps,
} from '@/components/elements/BillboardCard'
import { Divider } from '@/components/elements/Divider'

export interface ProperamentMoviesProps {
  title: string
  subtitle: string
  movies?: Record<string, BillboardCardProps[]>
}
const itemVariants: Variants = {
  enter: (index) => ({
    opacity: 1,
    scale: 1,
    transition: { delay: index * 0.05 + 0.5 },
  }),
  exit: (index) => ({
    opacity: 0,
    scale: 0.9,
    transition: { delay: index * 0.05 },
  }),
}

const BillboardsCardSection: React.FC<{ billboards: BillboardCardProps[] }> = ({
  billboards,
}) => (
  <div className="grid gap-x-10 gap-y-4 grid-cols-1 sm:grid-cols-3">
    <AnimatePresence initial={false}>
      {billboards.map((movie, index) => (
        <motion.div
          initial="exit"
          animate="enter"
          exit="exit"
          key={`${movie.id}`}
          variants={itemVariants}
          custom={index}
        >
          <BillboardCard {...movie} />
        </motion.div>
      ))}
    </AnimatePresence>
  </div>
)

const BillboardsSection: React.FC<{
  year
  billboards: BillboardCardProps[]
  last
}> = ({ year, billboards, last = false }) => (
  <Container>
    <p className="mb-5 text-left font-display text-2xl font-bold md:mb-10 md:text-3xl">
      {year}
    </p>
    <BillboardsCardSection billboards={billboards} />
    {!last && <Divider variant="secondary" />}
  </Container>
)

export const ProperamentMovies: React.FC<ProperamentMoviesProps> = ({
  movies,
  title,
  subtitle,
}) => {
  const haveMovies = !!movies

  return (
    <section id="incoming-movies">
      <Container className="mb-14 mt-10 w-full md:mb-24 md:mt-20">
        <SectionTitle
          title={title}
          subtitle={subtitle}
          marginBottom={false}
          className="mb-10 md:mb-20"
        />
        {haveMovies ? (
          <section>
            {Object.entries(movies).map(([key], index) => {
              movies[key].sort((a, b) => {
                return new Date(a.date).getTime() - new Date(b.date).getTime()
              })
              return (
                <BillboardsSection
                  key={key}
                  year={key}
                  billboards={movies[key]}
                  last={Object.entries(movies).length === index + 1}
                />
              )
            })}
          </section>
        ) : (
          <div className="flex flex-col items-center py-2 text-xl">
            <IonIcon className="mr-2 w-32" icon={GlassesOutline} />
            <h3 className="text-center text-6xl font-black leading-none">
              Sense Pel·lícules Properes
            </h3>
          </div>
        )}
      </Container>
    </section>
  )
}
